import { computed, onBeforeMount, onUpdated, ref } from 'vue'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'

export default {
    name: 'StafetAddDeltager',
    components: {
        FormInputDropdown,
        FormInputTextField
    },
    props: {
        labels: {
            type: Object,
            required: true
        },
        displayInputError: {
            type: Boolean,
            required: false,
            default: false
        },
        onChangeCallback: {
            type: Function,
            required: true
        },
        data: {
            type: Object,
            required: false
        },
        excludeMail: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const numberOfAdults = ref(0)
        const numberOfChildren = ref(0)
        const adults = ref([])
        const children = ref([])
        const callbackData = ref({})

        const totalNumberOfParticipants = computed(() => {
            return numberOfAdults.value + numberOfChildren.value
        })

        onBeforeMount(() => {
            if (props.data) {
                numberOfAdults.value = props.data.children.length
                numberOfChildren.value = props.data.adults.length
                adults.value = props.data.adults
                children.value = props.data.children
                validateParticipants()
                handleCallbackData()
            }
        })

        const updateAdults = (value) => {
            if (adults.value.length > value) {
                adults.value = adults.value.slice(0, value)
            } else if (value === 0) {
                adults.value = []
            } else {
                const diff = value - adults.value.length
                for (let i = 0; i < diff; i++) {
                    adults.value.push({
                        name: '',
                        email: '',
                        isValid: false
                    })
                }
            }
        }

        const updateChildren = (value) => {
            if (children.value.length > value) {
                children.value = children.value.slice(0, value)
            } else if (value === 0) {
                children.value = []
            } else {
                const diff = value - children.value.length
                for (let i = 0; i < diff; i++) {
                    children.value.push({
                        name: '',
                        email: '',
                        isValid: false
                    })
                }
            }
        }

        const setNumberOfAdults = (value) => {
            const intValue = parseInt(value)
            numberOfAdults.value = intValue ? (intValue > 0 ? intValue : 0) : 0

            updateAdults(intValue)
        }

        const setNumberOfChildren = (value) => {
            const intValue = parseInt(value)
            numberOfChildren.value = intValue
                ? intValue > 0
                    ? intValue
                    : 0
                : 0

            updateChildren(intValue)
        }

        const validateParticipants = () => {
            let isNumberOfParticipantsValid =
                numberOfAdults.value + numberOfChildren.value > 0
            let isAdultsValid = true
            let isChildrenValid = true

            if (adults.value.length > 0) {
                fieldsValiditiy(adults.value)
                isAdultsValid = adults.value.every((adult) => adult.isValid)
            }

            if (children.value.length > 0) {
                fieldsValiditiy(children.value)
                isChildrenValid = children.value.every((child) => child.isValid)
            }

            callbackData.value.adults = adults.value
            callbackData.value.children = children.value
            callbackData.value.isValid =
                isNumberOfParticipantsValid && isAdultsValid && isChildrenValid
        }

        const fieldsValiditiy = (fields) => {
            fields.forEach((field) => {
                if (props.excludeMail) {
                    field.isValid = nonEmptyStringValidator(field.name)
                } else {
                    field.isValid =
                        nonEmptyStringValidator(field.name) &&
                        emailValidator(field.email)
                }
            })
        }

        const handleCallbackData = () => {
            if (props.onChangeCallback) {
                props.onChangeCallback(callbackData.value)
            }
        }

        onUpdated(() => {
            validateParticipants()
            handleCallbackData()
        })

        return {
            numberOfAdults,
            numberOfChildren,
            totalNumberOfParticipants,
            adults,
            children,
            setNumberOfAdults,
            setNumberOfChildren,
            nonEmptyStringValidator,
            emailValidator
        }
    }
}
